module.exports = __webpack_public_path__ + "static/media/Heart_Roto.fd9b223c.svg";